module.exports = "/static/images/logo-new-horizontal.svg";